import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const VehicleList = Loadable(lazy(() => import('./VehicleList')));

const VehicleRoutes = [
	{
		path: '/vehicle',
		element: <VehicleList />,
		auth: authRoles.admin,
	},
];

export default VehicleRoutes;
